// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "BusinessProVisitorLazyComponent" + "." + "a994c475cb4741a6943a" + ".js";
};